import { render, staticRenderFns } from "./activeTrend.vue?vue&type=template&id=80fb98bc&scoped=true&"
import script from "./activeTrend.vue?vue&type=script&lang=js&"
export * from "./activeTrend.vue?vue&type=script&lang=js&"
import style0 from "./activeTrend.vue?vue&type=style&index=0&id=80fb98bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fb98bc",
  null
  
)

export default component.exports